import toAdmin from "@utils/toAdmin";

export const getPlatforms = () => {
  return toAdmin.get("admin", "platforms");
};

export const getSpecificPlatform = (platform_id) => {
  return toAdmin.get("admin", `platforms/${platform_id}`);
};
